import React, { useState, useContext, useEffect } from "react";
import useMediaQuery from "@mui/material/useMediaQuery";
import { locations } from "../../data/Data";
import {
  Box,
  Typography,
  Select,
  MenuItem,
  TextField,
  FormHelperText,
  InputLabel,
  Checkbox,
  Radio,
  RadioGroup,
  FormControlLabel,
  Divider,
} from "@mui/material";
import { FormContext } from "./Form";

const ThankYouPage = () => {
  const { setCurrentStep, data, setData } = useContext(FormContext);
  const matches = useMediaQuery("(max-width:480px)");
  const confirm_Location_operation_hours = locations.find(
    (loc) => loc.value === data?.location
  );
  const {
    confirmedShopTC = "1",
    confirmedShopEN = "1",
  } = confirm_Location_operation_hours;

  return (
    <Box>
      <Box sx={{ width: "100%", marginBottom: "20px" }}>
        <Typography
          variant="h6"
          sx={{ textAlign: "center", fontWeight: "bold", marginBottom: "20px" }}
        >
          Here is your exclusive offer!
          <br /> 您已獲得限定禮遇！
        </Typography>
        <Typography variant="body1" sx={{ marginBottom: "20px" }}>
          Pre order at Samsung Online Shop or Samsung Shop App, or pay a deposit
          at your chosen Samsung Experience Store{" "}
          <b>
            <u>on 9 February or before</u>
          </b>{" "}
          to confirm your pre-order and claim your exclusive offer for the new
          Galaxy S25 Series or Galaxy Book5 Series.
          <br />
          <br />請
          <b>
            <u>於2月9日或之前</u>
          </b>
          於Samsung 網上商店、Samsung Shop App 預訂全新 Galaxy S25 系列或 Galaxy Book5系列，或親臨您所選擇的三星專門店，繳付訂金以確認預訂及獲取限定禮遇。
        </Typography>
        <Divider sx={{ borderColor: "rgba(0, 0, 0, 0.6)" }} />
        <Typography
          variant="body1"
          sx={{ fontWeight: "bold", marginTop: "20px" }}
        >
          Registration details<br></br>
          登記資料
        </Typography>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            flexDirection: matches ? "column" : "row",
          }}
        >
          <Typography
            variant={matches ? "subtitle2" : "subtitle1"}
            sx={{
              display: "flex",
              flexDirection: "row",
              width: matches ? "100%" : "50%",
              margin: "20px 0",
            }}
          >
            <Box sx={{ width: "160px" }}>
              Last Name<br></br>
              姓氏
            </Box>
            <Box sx={{ width: "200px" }}>{data?.last_name}</Box>
          </Typography>
          <Typography
            variant={matches ? "subtitle2" : "subtitle1"}
            sx={{
              display: "flex",
              flexDirection: "row",
              width: matches ? "100%" : "50%",
              margin: "20px 0",
            }}
          >
            <Box sx={{ width: "160px" }}>
              First Name<br></br>
              名字
            </Box>
            <Box sx={{ width: "200px" }}>{data?.first_name}</Box>
          </Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            flexDirection: matches ? "column" : "row",
          }}
        >
          <Typography
            variant={matches ? "subtitle2" : "subtitle1"}
            sx={{
              display: "flex",
              flexDirection: "row",
              width: matches ? "100%" : "50%",
              margin: "20px 0",
            }}
          >
            <Box sx={{ width: "160px" }}>
              Mobile Number
              <Typography variant="subtitle2">
                (To receive WhatsApp messages)
              </Typography>
              流動電話號碼
              <Typography variant="subtitle2">
                (可接收 WhatsApp 訊息)
              </Typography>
            </Box>
            <Box sx={{ width: "200px" }}>
              +{data?.select?.value} {data?.mobile_number}
            </Box>
          </Typography>
          <Typography
            variant={matches ? "subtitle2" : "subtitle1"}
            sx={{
              display: "flex",
              flexDirection: "row",
              width: matches ? "100%" : "50%",
              margin: "20px 0",
            }}
          >
            <Box sx={{ width: "160px" }}>
              Email Address<br></br>
              電郵地址
            </Box>
            <Box sx={{ width: "200px" }}>{data?.email}</Box>
          </Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            flexDirection: matches ? "column" : "row",
          }}
        >
          <Typography
            variant={matches ? "subtitle2" : "subtitle1"}
            sx={{
              display: "flex",
              flexDirection: "row",
              width: matches ? "100%" : "50%",
              margin: "20px 0",
            }}
          >
            <Box sx={{ width: "160px" }}>
              Samsung Experience Store<br></br>
              三星專門店
            </Box>
            <Box sx={{ width: "200px" }}>
              {confirmedShopEN}
              <br />
              {confirmedShopTC}
            </Box>
          </Typography>
        </Box>
        <Divider sx={{ borderColor: "rgba(0, 0, 0, 0.6)" }} />
        <Box sx={{ marginTop: "20px" }}>
          <Typography variant="body1" sx={{ fontWeight: "bold" }}>
            Enjoy up to HK$2,000 CashBack with designated Standard Chartered
            Credit Cards! <sup>1</sup> <br></br>
            憑指定渣打銀行信用卡簽賬，享高達港幣$2,000現金回贈！<sup>1</sup> 
          </Typography>
          <br></br>
          <Typography variant="body1">
            <sup>1</sup>
             於整個推廣期內，每位持卡人最高可獲得港幣2,000元現金回贈。優惠受條款及細則約束。借定唔借？還得到先好借！相關回贈將於2025年2月28日或之前存入持卡人相關的有效信用卡戶口或綜合理財戶口。
            <br></br>
            <sup>1</sup> During the entire promotion period, each cardholder is
            entitled to a maximum of HK$2,000 cash rebate. Terms & conditions
            apply. To borrow or not to borrow? Borrow only if you can repay! The
            cash rebate of this promotion will be credited to relevant
            cardholder’s valid credit card account or integrated account by 28
            February 2025.
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default ThankYouPage;
